
import { defineComponent, ref } from 'vue'
import PageContent from '@/components/page-content'
import OperatorDialog from './components/operator-dialog.vue'
import { contentTableConfig } from './config/content.config'
import { getOperatorTree,changeOperator,deleteOperator,getWxaCode  } from '@/service/main/system/system'
import { ElMessageBox,ElMessage } from 'element-plus'

export default defineComponent({
  name: 'operator',
  components: {
    PageContent,
    OperatorDialog
  },
  setup() {
    const operatorRef = ref()
    const dialogVisible = ref(false)
    const isEdit = ref(false)
    const currentRow = ref<any>({})
    const deptTree = ref<any[]>()
    // 小程序码相关
    const qrcodeDialogVisible = ref(false)
    const qrcodeUrl = ref('')
    const getOperatorList = async () => {
      const res: any = await getOperatorTree('/system/dept/list', {})
      deptTree.value = res?.data.filter((item: any) => item.deptId == 100)
    }
    getOperatorList()

    // 新增
    const openAddDialog = () => {
      isEdit.value = false
      currentRow.value = {
        parentId: '',
        deptName: '',
        orderNum: 0,
        leader: '',
        phone: '',
        email: '',
        status: '0',
        locationFullName: '',
        locationCounty: '',
        locationProvince: '',
        locationCity: '',
      }
      dialogVisible.value = true
    }
    const openDeleteDialog = (row: any) => {
      ElMessageBox.confirm('确定删除该运营商吗？').then(() => {
        deleteOperator(`/system/dept/${row.deptId}`).then(() => {
          operatorRef.value.getPageData()
          ElMessage.success('删除成功')
        }).catch(err => {
          console.log(err)
        })
      }).catch(() => {
        ElMessage.warning('已取消删除')
      })
    }
    // 编辑
    const openEditDialog = (row: any) => {
      isEdit.value = true
      currentRow.value = { ...row }
      dialogVisible.value = true
    }
    // 提交
    const handleDialogSubmit = (form: any) => {
      if (isEdit.value) {
        // 编辑逻辑
        changeOperator('/system/dept', form,'put').then(() => {
          operatorRef.value.getPageData()
          dialogVisible.value = false
        }).catch(err => {
          console.log(err)
        })
      } else {
        changeOperator('/system/dept', form).then(() => {
          operatorRef.value.getPageData()
          dialogVisible.value = false
        }).catch(err => {
          console.log(err)
        })
      }
    }
    const generateMiniProgramCode = (row: any) => {
      qrcodeUrl.value = '' // 清空之前的图片链接
      qrcodeDialogVisible.value = true // 打开弹窗，显示加载中
      
      getWxaCode('/app/server/getWxaCode', {
        inviteCode: row.inviteCode,
      }, 'blob').then((res: any) => {
        // 将二进制数据转换为Base64
        const reader = new FileReader()
        reader.readAsDataURL(res)
        reader.onload = () => {
          qrcodeUrl.value = reader.result as string
        }
      }).catch(() => {
        ElMessage.error('获取小程序码失败')
        qrcodeDialogVisible.value = false
      })
    }
    
    // 下载小程序码图片
    const downloadQrcode = () => {
      if (!qrcodeUrl.value) return
      
      // 创建一个a标签用于下载
      const link = document.createElement('a')
      link.href = qrcodeUrl.value
      link.download = '小程序码.png'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
    return {
      contentTableConfig,
      operatorRef,
      dialogVisible,
      isEdit,
      currentRow,
      deptTree,
      qrcodeDialogVisible,
      qrcodeUrl,
      openAddDialog,
      openEditDialog,
      openDeleteDialog,
      handleDialogSubmit,
      generateMiniProgramCode,
      downloadQrcode
    }
  }
})
